import { ElMessage, ElMessageBox } from "element-plus";
import { ref } from "vue";
import { deleteCategoryById } from "@/api/materiel";
export default function useCategoryEdit(getList) {
  // 编辑组件的ref
  const editRef = ref(null);
  // 点击新增或编辑
  const handleEdit = (row, type) => {
    editRef.value?.handleDialogOpen({
      row,
      type,
    });
  };

  // 点击删除
  const handleDelete = (row) => {
    ElMessageBox.confirm(`确定删除类别【${row.name}】吗?`, "删除", {
      confirmButtonText: "删除",
      cancelButtonText: "取消",
      type: "error",
    })
      .then(() => {
        deleteCategoryById(row.id).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("操作成功");
            getList();
          }
        });
      })
      .catch(() => {
        ElMessage.info("已取消");
      });
  };

  // 点击停用或启用
  const handleEnable = (row, type) => {
    ElMessageBox.confirm(
      `确定${type ? "启用" : "停用"}类别【${row.name}】吗?`,
      `${type ? "启用" : "停用"}`,
      {
        confirmButtonText: `${type ? "启用" : "停用"}`,
        cancelButtonText: "取消",
        type: `${type ? "success" : "error"}`,
      }
    )
      .then(() => {})
      .catch(() => {
        ElMessage.info("已取消");
      });
  };
  return {
    editRef,
    handleEdit,
    handleDelete,
    handleEnable,
  };
}
